import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { LiftErrorList } from '../models/lift-error-list.model';
import { IFetchList } from 'src/app/core/services/fetch-entity.interface';

@Injectable({
  providedIn: 'root'
})
export class LiftErrorService implements IFetchList {
  apiUrl: string;
  apiAgregateUrl: string;
  headers: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private httpClient: HttpClient,
    @Inject('BASE_URL') baseUrl: string) {
    this.apiUrl = baseUrl + 'api/LiftModuleError';
    this.apiAgregateUrl = baseUrl + 'api/LiftModuleError/fromlastlogin';
  }

  get(params: HttpParams, id: number) {
    const url = this.apiUrl + '/' + String(id);

    return this.httpClient.get<LiftErrorList[]>(url, { params: params, observe: 'response' });
  }

  getCompanyErrorsFromLastLogin(params: HttpParams) {
    return this.httpClient.get<LiftErrorList[]>(this.apiAgregateUrl, { params: params, observe: 'response' });
  }

  delete(id: number) {
    const url = this.apiUrl + '/' + String(id);
    return this.httpClient.delete(url);
  }
}
